import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Quote: FC<IconSvgProps> = () => {
    return (
        <svg width="85px" height="85px" viewBox="0 0 85 85">
            <path
                d="M122.731707,85 C129.902439,85 132.292683,82.2017937 132.292683,74.0695067 C132.292683,66.8116592 130.329268,63.838565 125.036585,63.2264574 L134,46 L125.804878,46 C121.536585,50.5470852 113,61.0403587 113,74.2443946 L113.085366,74.2443946 C113.085366,82.2017937 115.646341,85 122.731707,85 Z M152.731707,85 C159.902439,85 162.292683,82.2017937 162.292683,74.0695067 C162.292683,66.8116592 160.329268,63.838565 155.036585,63.2264574 L164,46 L155.804878,46 C151.536585,50.5470852 143,61.0403587 143,74.2443946 L143.085366,74.2443946 C143.085366,82.2017937 145.646341,85 152.731707,85 Z"
                id="“"
                fill="#FFFFFF"
                transform="translate(-110, -40)"
            ></path>
        </svg>
    );
};

export default Quote;
